import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play_outline",
  "use": "play_outline-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"play_outline\"><path d=\"M13.73 7.24L5.94 3.05c-.2-.11-.42-.16-.62-.16C4.63 2.89 4 3.44 4 4.2v9.6c0 .77.63 1.32 1.32 1.32.21 0 .42-.05.62-.16l7.79-4.19c1.4-.76 1.4-2.78 0-3.53zm-.71 2.2L5.5 13.49V4.51l7.52 4.05c.23.12.26.33.26.44 0 .11-.03.32-.26.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol